import * as React from "react";
import { useSelect } from "@hubper/theme";
import Icon, { IconName } from "../../elements/Icon";
import Tag from "../../components/Tag";

export type Props = {
  style?: React.CSSProperties;
  className?: string;
  iconName: IconName;
  text: string;
};

function ActivityTypeTag(
  { style, className, iconName, text }: Props,
  ref: any
) {
  const select = useSelect();
  return (
    <Tag
      ref={ref}
      style={style}
      className={className}
      text={text}
      c="rgba(255, 255, 255, 0.9)"
      beforeText={
        <Icon
          size={12}
          c={["grey", 8]}
          name={iconName}
          style={{ marginLeft: select.space(2) }}
        />
      }
      textProps={{ style: { paddingLeft: 6 }, c: ["grey", 8] }}
    />
  );
}

export default React.forwardRef(ActivityTypeTag);
